import { Popover, PopoverProps, styled, Text, View } from "tamagui";

const Content = styled(Popover.Content, {
  name: "Content",
  borderColor: "$gray-600",
  borderRadius: "$5",
  borderWidth: "$0.2",
  padding: "$2",
});

const NavbarPopoverItemContainer = styled(View, {
  name: "NavbarPopoverItemContainer",
  flexDirection: "row",
  gap: "$0.5",
  justifyContent: "center",
  alignItems: "flex-start",
  variants: {
    last: {
      true: {
        height: "$2.5",
      },
      false: {
        height: "$4.2",
      },
    },
  } as const,
  defaultVariants: {
    last: false,
  },
});

const NavbarPopoverItemText = styled(Text, {
  name: "NavbarPopoverItemText",
  fontFamily: "$body",
  fontWeight: "$4",
  fontSize: "$3",
  lineHeight: "$3",

  variants: {
    variant: {
      default: {
        color: "$gray-primary-900",
      },
      danger: {
        color: "$error-500",
      },
    },
  } as const,
  defaultVariants: {
    variant: "default",
  },
});

export const NavbarPopoverBody: React.FC<PopoverProps> = ({
  children,
  ...rest
}) => {
  return <Popover {...rest}>{children}</Popover>;
};

export const NavbarPopover = {
  Body: NavbarPopoverBody,
  Trigger: Popover.Trigger,
  Close: Popover.Close,
  Content,
  ItemText: NavbarPopoverItemText,
  Item: NavbarPopoverItemContainer,
};
